export default {
  Notify: {
    TitlePopupFail: 'Oops!',
    MessageTeaherRefuseStudent: 'Yêu cầu tham gia lớp <b>{ClassName}</b> đã bị từ chối. Vui lòng liên hệ với giáo viên <b>{TeacherName}</b> để biết thêm chi tiết nhé!',
    MessageTeacherKickStudent: 'Bạn không được tham gia lớp <b>{ClassName}</b> nữa. Vui lòng liên hệ với giáo viên <b>{TeacherName}</b> để biết thêm chi tiết nhé!',
    TeacherStopFollowClass: 'Lớp <b>{ClassName}</b> đã bị ngừng theo dõi.<br/>Vui lòng liên hệ giáo viên <b>{TeacherName}</b> để biết thêm chi tiết.',
    TeacherDeleteClass: 'Lớp <b>{ClassName}</b> đã bị xóa.<br/>Vui lòng liên hệ giáo viên <b>{TeacherName}</b> để biết thêm chi tiết.',
    TeacherDeleteExamPeriod: 'Giáo viên <b>{TeacherName}</b> đã xóa bài kiểm tra <b>{ExamName}</b>.',
    TeacherDeleteExamResult: 'Giáo viên <b>{TeacherName}</b> đã thu hồi kết quả bài kiểm tra <b>{ExamName}</b>.',

    TimeTemplate: {
      JustNow: 'Vừa xong',
      MinutesAgo: '{minutes} phút trước',
      HoursAgo: '{hours} giờ trước',
      Yesterday: 'Hôm qua lúc {hour}:{minute}',
      SameWeek: '{day} lúc {hour}:{minute}',
      SameYear: '{date} tháng {month}, lúc {hour}:{minute}',
      DifferentYear: '{date} tháng {month} năm {year}, lúc {hour}:{minute}'
    }
  }
}
